import type { ColDef } from 'ag-grid-community';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { AgGridReact } from 'ag-grid-react';
import { Button, Modal, Select, Table, message, DatePicker, Popconfirm} from 'antd';
import type { ColumnsType } from "antd/es/table";
import React, { useEffect, useMemo, useState, useRef } from 'react';
import { RowFiling, FetchFilingRequest, FilingProps, FilingData, ExcelFilingRequest } from '../constant';
import { FectchFiling } from "../api/FetchFiling";
import { convertToRowFiling, isFetchFilingResponse, parsingCarrier } from '../common';
import DOMPurify from 'dompurify';
import ReverseButtonComponent from '../components/ReverseButtonComponent'
import dayjs from 'dayjs';
import type { Dayjs } from 'dayjs'
import { ReverseFiling } from "../api/cudFiling";
import { DownloadBuildSL } from '../api/buildsl';
import { DownloadExcelFiling } from '../api/exceloutFiling';
import { FileExcelOutlined } from '@ant-design/icons';
import CustomLoadingOverlay from '../components/CustomLoadingOverlay';

import {
    AllCommunityModule,
    CheckboxEditorModule,
    ClientSideRowModelModule,
    ModuleRegistry,
    themeQuartz,
    ValidationModule
} from "ag-grid-community";
import moment from 'moment';

ModuleRegistry.registerModules([AllCommunityModule, CheckboxEditorModule, ClientSideRowModelModule, ValidationModule]);

const HeaderStyle: React.CSSProperties = {
    height: '170px',
    backgroundColor: 'rgb(238,238,238)'
};

const SelectStyle: React.CSSProperties = {
    fontFamily: "Arial, Verdana, sans-serif",
    fontSize: "11px",
    width: "160px",
    height: "22px"
};

const ButtonStyle: React.CSSProperties = {
    fontFamily: "Arial, Verdana, sans-serif",
    fontSize: "11px",
    width: "160px",
    height: "23px"
};

const DatePickerStyle: React.CSSProperties = {
    fontFamily: "Arial, Verdana, sans-serif",
    fontSize: "11px",
    width: "160px",
    height: "23px"
};

const TableContainer: React.CSSProperties = {
    height: 'calc(100vh - 310px)',
  };

const ReportHelpStyle: React.CSSProperties = {
    minHeight: '100px',
    maxHeight: '400px',
    overflowY: 'auto'
};

//const reportperiod = ["2024A","2023B","2023A","2022B","2022A","2021B","2021A","2020B","2020A","2019B","2019A","2018B","2018A","2017B","2017A","2016B","2016A", "Transaction Date"]
//const reportperiod = ["2024A","2023B","2023A","2022B","2022A","2021B","2021A","2020B"]
const transaction = ["Arizona only","Multi-state (AZ homestate)","All"]

  const Reports: React.FC<FilingProps> = ({user, slcodes}) => {

    const [loading, setLoading] = useState(false);
    const [rowData, setRowData] = useState<RowFiling[]>([]);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [carrierrows, setCarrierrows] = useState<any[]>([]);
    const [selectPeriod, setSelectPeriod] = useState<string>("");
    const [disabledDataType, setdisabledDataType] = useState<boolean>(true);
    const [datetypevalue, setDateTypeValue] = useState<string>("Effective Date");
    const [disabledTransation, setdisabledTransation] = useState<boolean>(true);
    const [transationvalue, setTransationValue] = useState<string>("Arizona only");
    const [disabledStartDate, setdisabledStartDate] = useState<boolean>(true);
    const [startdatevalue, setStartDateValue] = useState<Date>(new Date("01/01/2018"));
    const [disabledEndDate, setdisabledEndDate] = useState<boolean>(true);
    const [enddatevalue, setEndDateValue] = useState<Date>(new Date("01/30/2018"));
    const [disabledRunSemi, setdisabledRunSemi] = useState<boolean>(false)
    const [runsemiTitle, setRunsemiTitle] = useState<string>("Run Tax Report (E-SL)");
    const [period, setPeriod] = useState<string>("");
    const [codebase, setCodebase] = useState<string>("new");
    const [isReportHelpModal, setIsReportHelpModal] = useState(false)
    const [reporthelp_html, setReportHelp_html] = useState<string>('');
    const [filingList, setFilingList] = useState<FilingData[]>([]);
    const listRef = useRef(filingList);
    const [periodlist, setPeriodList] = useState<string[]>([]);

    const [colDefs, setColDefs] = useState<ColDef[]>([
        { 
            headerClass: 'reverse-header',
            headerName : "",
            field: "reverse",
            editable: false,
            width: 30,
            cellRenderer: (params: any) => (
                <ReverseButtonComponent
                    api={params.api}
                    node={params.node}
                    onReverseButton={onReverseFiling}
                />
              ),
        },
        { headerName:'Late?', field: "late", width: 70, resizable: true},
        { headerName:'Policy Number', field: "policynumber", width: 150, resizable: true,  cellStyle: { textAlign: "left" }},
        { headerName:'Trans Type', field: "transType", width: 60, resizable: true},
        { headerName:'Insured Name', field: "insuredName", width: 200, resizable: true,  cellStyle: { textAlign: "left" }},
        { headerName:'Insured City, State Zip', field: "insuredAddress", width: 220, resizable: true,  cellStyle: { textAlign: "left" }},
        { headerName:'Transaction Effective Date', field: "transEffectiveDate", width: 100, resizable: true, 
            valueFormatter: (params) => {
            const value = params.value;
            return value ? moment(value).format('MM/DD/YYYY') : '';
            },
        },
        { headerName:'Transaction Date', field: "transDate", width: 100, resizable: true, 
            valueFormatter: (params) => {
            const value = params.value;
            return value ? moment(value).format('MM/DD/YYYY') : '';
            },
        },
        { headerName:'Class Code', field: "slCode", width: 270, resizable: true,  cellStyle: { textAlign: "left" }},
        { headerName:'Premium', field: "premium", width: 90, resizable: true ,  cellStyle: { textAlign: "right" } },
        { headerName:'Policy Fees', field: "policyFee", width: 70, resizable: true ,  cellStyle: { textAlign: "right" }},
        { headerName:'State Tax (3%)', field: "tax", width: 80, resizable: true, editable: false,  cellStyle: { textAlign: "right" }},
        { headerName:'Stamping Fee (0.2%)', field: "stampingFee", width: 90, resizable: true, editable: false,  cellStyle: { textAlign: "right" }},
        { headerName: 'Carriers', field: 'carriers', width: 800,  editable: false,  cellStyle: { textAlign: "left" }},
    ]);

    useEffect(() => {
      listRef.current = filingList;
    }, [filingList]);
    
    useEffect(() => {
        setPeriodList(generateReportPeriod())
        setSelectPeriod(generateReportPeriod()[0])
      },[]);

    const generateReportPeriod = (): string[] => {
        const startYear = 2016; 
        const currentDate = dayjs();
        const currentYear = currentDate.year(); 
        const isSecondHalf = currentDate.month() >= 6; 
        
        const periods: string[] = [];
        if (isSecondHalf) {
            periods.push(`${currentYear}A`);
        }

        for (let year = currentYear - 1; year >= startYear; year--) {
            periods.push(`${year}B`);
            periods.push(`${year}A`);
        }

        periods.push("Transaction Date");
        return periods; 
    };

    const defaultColDef = useMemo<ColDef>(() => {
    return {
        headerClass: 'custom-header',
        sortable: false,
    };
    }, []);

    const myTheme = themeQuartz
    .withParams({
        headerColumnBorder: { color: 'gray' },
        headerColumnBorderHeight: '90%',
    });

    const onReverseFiling = (rowIndex: number) => {
        ReverseFiling(listRef.current[rowIndex].id, user.licenseNumber)
        .then((result) => {
            if (result.success)
            {
                message.success(result.errorMsg)
            }
            else{
                message.error(result.errorMsg)
            }
        })
        .catch((error) => {
            console.error("An error occurred:", error.message);
            return
        });
    }
    
    const handleTransClick = () =>{

        let searchword = ""

        if (datetypevalue !== "Transaction Date")
        {
            searchword = `period=${selectPeriod}`
        }
        else{
            const start = startdatevalue.toLocaleDateString("en-US")
            const end = enddatevalue.toLocaleDateString("en-US")
            searchword = `transdatestart=${start},transdateend=${end}`
        }

        const filingrequest: FetchFilingRequest = {
            userid: 0,
            posted: "Y",
            searchWords: searchword,
            licenseNumber: user.licenseNumber,
        }
        setLoading(true);
        FectchFiling(filingrequest)
        .then((fetchFilingResult) => {
            if (fetchFilingResult.success)
            {
                //message.success({ content: 'Success to load the filings', key: 'ReportStatus', duration: 2  });
                if (isFetchFilingResponse(fetchFilingResult))
                {
                    setFilingList(fetchFilingResult.fetchedList)
                    setRowData(convertToRowFiling(fetchFilingResult.fetchedList, slcodes))
                }
            }
            else{
                if ("errorMsg" in fetchFilingResult) {
                    message.error({ content: 'Failed to load the filings', key: 'ReportStatus', duration: 2  });
                    //message.error(fetchFilingResult.errorMsg)
                }
            }
        })
        .catch((error) => {
            console.error("An error occurred:", error.message);
            return
        })
        .finally(() => {
            setLoading(false);
        });
    }

    const handleBuildslClick = () =>{
        message.loading({ content: 'Running Tax Report...', key: 'taxReport', duration: 0});
        DownloadBuildSL(selectPeriod, user.licenseNumber)
        .then((response) => {
            if (response.success)
            {
                message.success({ content: response.errorMsg, key: 'taxReport', duration: 2})
                //message.destroy('taxReport')
            }
            else{
                message.error({ content: response.errorMsg, key: 'taxReport', duration: 2})
            }
        })
        .catch((error) => {
            console.error("An error occurred:", error.message);
            return
        });
    }
    const DownloadFilingExcel = (bshort: boolean) => {
        if (rowData.length === 0)
            return

        let searchword = ""
        if (datetypevalue !== "Transaction Date")
        {
            searchword = `period=${selectPeriod}`
        }
        else{
            const start = startdatevalue.toLocaleDateString("en-US")
            const end = enddatevalue.toLocaleDateString("en-US")
            searchword = `transdatestart=${start},transdateend=${end}`
        }

        const excelrequest: ExcelFilingRequest = {
            fetchRequest:{
                userid: 0,
                posted: "Y",
                searchWords: searchword,
                licenseNumber: user.licenseNumber,
            },
            bShort: bshort
        }
        message.loading({ content: 'Excel File Downloading...', key: 'downloadexcel', duration: 0  });
        DownloadExcelFiling(excelrequest)
        .then((excelFilingResult) => {
        if (excelFilingResult.success)
        {
            message.success({ content: excelFilingResult.errorMsg, key: 'downloadexcel', duration: 2 })
        }
        else{
            message.error({ content: excelFilingResult.errorMsg, key: 'downloadexcel', duration: 2 })
        }
        })
        .catch((error) => {
        console.error("An error occurred:", error.message);
        return
        });
        
    }

    const ShortFormExcel = () =>{
        DownloadFilingExcel(true)
    }

    const LongFormExcel = () =>{
        DownloadFilingExcel(false)
    }

    const onCellValueChanged = (params: any) => {
        params.node.setDataValue("validate", isValidate(params.data) === true? "" : "!")
    };
    const onCellDoubleClicked = (params: any) => {
        if (params.colDef.field === "carriers") {
            showModal(params.data.carriers)
        }
    };

    const isValidate = (data: any) => {

        return true
    }

    const showModal = (data: string) => {
        const initrow = data === ""? []: data
        .split(" / ") 
        .map((item, index) => {
            console.log(item)
            const match = parsingCarrier(item)
            if (match) {
                return { key: index, carrier: match[0], percent: match[1]};
            }
            return [];
        })

        setCarrierrows(initrow)
        setIsModalVisible(true);
    }

    const handleCancel = () => {
        setIsModalVisible(false);
        setCarrierrows([]);
    }

  
    const handleOk = () => {

    };

    const handleHelpCancel = () =>{
        setIsReportHelpModal(false)
    }

    const showSearchHelpModal = () => {
        const fetchSearchHelpHtml = async () => {
            try {
                const response = await fetch('/html/report.html'); 
                if (response.ok) {
                const htmlContent = await response.text();
                setReportHelp_html(DOMPurify.sanitize(htmlContent));
                } else {
                console.error('Failed to load aboutus.html');
                }
            } catch (error) {
                console.error('Error fetching aboutus.html:', error);
            }
            };
            
        fetchSearchHelpHtml()
        setIsReportHelpModal(true);
    }

    const onSelectPeriodChanged = (value: string) => {
        console.log(`onSelectPeriodChanged : ${value}`)
        setSelectPeriod(value)  
        if (value === "Transaction Date")
        {
            setTransationValue("all")
            setDateTypeValue("Transaction Date")
            setdisabledEndDate(false)
            setdisabledStartDate(false)
            setdisabledRunSemi(true)
            setRunsemiTitle("Run Tax Report (E-SL)")
        }
        else{
            setdisabledDataType(true)
            setdisabledTransation(true)
            setdisabledStartDate(true)
            setdisabledEndDate(true)
            setdisabledRunSemi(false)
            setRunsemiTitle("Run Tax Report (E-SL)")
            setTransationValue("Arizona only")
            setDateTypeValue("Effective Date")

            const year = value.substring(0, 4)
            const isHalf = value.slice(-1) === "A" ? true: false 
            if (isHalf)
            {
                setStartDateValue(new Date(`1/1/${year}`))
                setEndDateValue(new Date(`6/30/${year}`))
            }
            else{
                setStartDateValue(new Date(`7/1/${year}`))
                setEndDateValue(new Date(`12/31/${year}`))
            }
            setPeriod(value)
            setCodebase("new")
        }
    }

    interface DataType {
        key: string;       
        carrier: string;    
        percent: number;    
    }
    const columns: ColumnsType<DataType> = [
      {
        title: "Carrier",
        dataIndex: "carrier",
        key: "carrier",
        width:"400px",
        align:"center"
      },
      {
        title: "Percent",
        dataIndex: "percent",
        key: "percent",
        width:"60px",
        
      },
    ];

    const dateFormat = 'MM/DD/YYYY'

    const handleStartDateValue = (date: Dayjs) => {
        if (date) {
            setStartDateValue(date.toDate())
        } else {
            setStartDateValue(new Date("01/01/2018"))
        }
    }

    const handleEndDateValue = (date: Dayjs) => {
        if (date) {
            setEndDateValue(date.toDate())
        } else {
            setEndDateValue(new Date("01/01/2018"))
        }
    };

    return(
        <div style={{height:'100%'}} className='text-style text-xs'>
            <div className="flex justify-between bg-gray-100" style={HeaderStyle}>
                <div >
                    <div className='flex flex-row ml-10 mt-5'>
                        <label className="mt-1 w-20 text-right" >Report Period: </label>
                        <div className="ml-2">
                            <Select
                                defaultValue={generateReportPeriod()[0]}
                                style={SelectStyle}
                                dropdownStyle={{ borderRadius: 0 }}
                                className='ml-0.5, mr-1.5 rectangular-select, custom-select'
                                onChange={onSelectPeriodChanged}
                                options={generateReportPeriod().map((item, index) => ({
                                    key: index,
                                    value: item, 
                                  }))}
                            />
                        </div>
                        <div className="ml-10">
                            <Button color="default" variant="outlined" className='ml-0.5, text-xs' onClick={handleTransClick} style={ButtonStyle}>
                                Run Transaction Report
                            </Button>
                        </div>
                    </div>
                    <div className='flex flex-row ml-10 mt-1'>
                        <label className="mt-1 w-20 text-right text-gray-500" >Data Type: </label>
                        <div className="ml-2">
                            <Select
                                defaultValue={"Effective Date"}
                                style={SelectStyle}
                                disabled={disabledDataType}
                                value={datetypevalue}
                                dropdownStyle={{ borderRadius: 0 }}
                                className='ml-0.5, mr-1.5 rectangular-select, custom-select'
                                onChange={onSelectPeriodChanged}
                                options={[{key: 1, value:"Effective Date"},{key: 2, value:"Transaction Date"}]}
                            />
                        </div>
                        <div className="ml-10">
                            <Button color="default" variant="outlined" className='ml-0.5, text-xs' style={ButtonStyle} onClick={handleBuildslClick} disabled={disabledRunSemi}>
                                {runsemiTitle}
                            </Button>
                        </div>
                    </div>
                    <div className='flex flex-row ml-10 mt-1'>
                        <label className="mt-1 w-20 text-right text-gray-500" >Transation: </label>
                        <div className="ml-2">
                            <Select
                                defaultValue={"Arizona only"}
                                style={SelectStyle}
                                disabled={disabledTransation}
                                dropdownStyle={{ borderRadius: 0 }}
                                value={transationvalue}
                                className='ml-0.5, mr-1.5 rectangular-select, custom-select'
                                onChange={onSelectPeriodChanged}
                                options={transaction.map((item, index) => ({
                                    key: index,
                                    value: item, 
                                  }))}
                            />
                        </div>
                        <div className="ml-10">
                            <Button color="default" variant="outlined" className='ml-0.5, text-xs' onClick={showSearchHelpModal} style={ButtonStyle}>
                                Help!
                            </Button>
                        </div>
                    </div>
                    <div className='flex flex-row ml-10 mt-1'>
                        {disabledStartDate ?(<label className="mt-1 w-20 text-right text-gray-500" >start: </label>):(<label className="mt-1 w-20 text-right text-black" >start: </label>)}
                        <div className="ml-2">
                            <DatePicker
                                defaultValue={dayjs('01/01/2018', dateFormat)}
                                format={dateFormat}
                                style={DatePickerStyle}
                                onChange={handleStartDateValue}
                                disabled={disabledStartDate}
                            />
                        </div>
                    </div>
                    <div className='flex flex-row ml-10 mt-1'>
                        {disabledEndDate ?(<label className="mt-1 w-20 text-right text-gray-500" >end: </label>):(<label className="mt-1 w-20 text-right text-black" >end: </label>)}
                        <div className="ml-2">
                            <DatePicker
                                defaultValue={dayjs('01/01/2018', dateFormat)}
                                format={dateFormat}
                                onChange={handleEndDateValue}
                                style={DatePickerStyle}
                                disabled={disabledEndDate}
                            />
                        </div>
                    </div>
                </div>
                
                <div className="flex items-end mr-20">
                    <Popconfirm
                    placement="bottom"
                    overlayStyle={{ width: 300, height: 100, fontSize: 12}}
                    icon={null}
                    title="Long or Short Form?"
                    description="The short form is ideal for printing but does not include full details, the long form includes all details about the filing but does not print well."
                    okButtonProps={{ size: "small", style: { width: 80, fontSize: 12, backgroundColor: 'green', color: 'white'} }}
                    cancelButtonProps={{ size: "small", style: { width: 80, fontSize: 12,  backgroundColor: 'green', color: 'white'} }}
                    okText="Short Form"
                    cancelText="Long Form"
                    onConfirm={ShortFormExcel}
                    onCancel={LongFormExcel}
                    >
                        <Button 
                        variant="outlined" 
                        type='primary'
                        icon={<FileExcelOutlined className='icon-style'/>} 
                        className='mb-5 button-style'>
                            Save to Excel
                        </Button>
                    </Popconfirm>
                </div>
            </div>
            <div className="ag-theme-alpine" style={TableContainer}>
                <AgGridReact
                    rowData={rowData}
                    columnDefs={colDefs}
                    theme={myTheme}
                    defaultColDef={defaultColDef}
                    headerHeight={35}
                    rowHeight={25}
                    onCellValueChanged={onCellValueChanged}
                    onCellDoubleClicked={onCellDoubleClicked}
                    loading={loading}
                    loadingOverlayComponent={CustomLoadingOverlay}
                    loadingOverlayComponentParams={{message: "Loading..."}}
                />
            </div>

            <Modal
                title={
                    <div className='text-style' style={{ textAlign: "center", fontWeight: "bold" }}>
                        Carriers
                    </div>
                }
                className='text-style'
                open={isModalVisible}
                onCancel={handleCancel}
                onOk={handleOk}
                width={600}
                height={400}
                footer={null}
            >
                <Table
                    columns={columns}
                    dataSource={carrierrows}
                    pagination={false}
                    rowKey="key"
                />
            </Modal>
            <Modal
                title={
                    <div className='text-style' style={{ textAlign: "center", fontWeight: "bold" }}>
                        Report Help...
                    </div>
                }
                className='text-style'
                open={isReportHelpModal}
                width={600}
                height={500}
                onCancel={handleHelpCancel}
                footer={null}
            >
                <div style={ReportHelpStyle}>
                    <div dangerouslySetInnerHTML={{ __html: reporthelp_html }} />
                </div>
            </Modal>
        </div>
    )
}

export default Reports;